import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import {LoginService} from '../../login-service'
import { Pipe, PipeTransform } from '@angular/core'
 import Locals from 'ngx-editor/lib/Locals';

@Component({
    selector: 'cost-app',
    templateUrl: 'cost.component.html',
providers:[LoginService]
    // styleUrls: ['./cost.component.scss']
})

export class CostComponent implements OnInit {
  bidarray:any=[];
  tempHiredCollaboDetails: any;
  Accordian: any;
  tabStatus:string;
  userID: string;
  tempColaboActorDetails: any;
  userType:string;
  tempCollaboList: any;
  statusCollabos=[];
  tempCol=[];
  showbiddetails:boolean=true;
  tempPraposaBids:any;
  collaboList: any;
  EachCollaboHired: any;
  HiredColaboDetals: any;
  ColaboActorDetails: any;
  tempSubcollaboList: any;
  CollaboPraposalDetails: any[];
  IsSubCollabo: boolean;
  ActorpercentageId: any;
  Actorid: any;
  HiredUsers: any;
  EachCollaoBids: any;
  c: any;
  expandedIndex = 0;
  tempcollabos: any[];
  searchText: any;
  presentCollabos: any[];
  length: number;
  private isCollapsed: boolean = true;
    constructor(private loginService:LoginService,private router: Router) {  
       this.userID=localStorage.getItem('USERID');
       this.userType=localStorage.getItem("userType");
    
    this.GetHiredCollabarators();
    this.GetCollabos();}

    ngOnInit() {
      
    }
    opencollabo(item){
      this.c=item;
    }

    GetHiredCollabarators(){
      this.loginService.GetHiredCollabarators().subscribe(data=>
        {
            data = JSON.parse(data['_body']);
            this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));
  
  
  
        });
    }
    GetPraposalBids(){
      this.loginService.GetPraposalBids().subscribe(data=>
        {
            data = JSON.parse(data['_body']);
            this.tempPraposaBids=JSON.parse(JSON.stringify(data));
  
  
  
        });
    }
    calculateDiff(sentDate,enddate) {
      var date1:any = new Date(sentDate);
      var date2:any = new Date(enddate);
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
  
      return diffDays;
  }
  Edit(row){
  
    this.router.navigate(['/initatorpostcollabo', row.id,'edit']);
  }
  backtoCost()
  {
    this.showbiddetails=true;
  }
  CollaboDetails(row)
  {
    this.length=row.praposalBids.length;
   this.bidarray=row.praposalBids;
    this.showbiddetails=false;
 
  }
    GetCollabos(){
        this.statusCollabos=[];
        this.tempCol=[];
           this.loginService.GetCollabos(this.userType).subscribe(data=>
               {
                   data = JSON.parse(data['_body']);
   
                   this.tempCollaboList=JSON.parse(JSON.stringify(data));
                
                   if(this.tempCollaboList==undefined)
                   {this.statusCollabos=[];
                    
                   return;}
   if(this.tempCollaboList.length>0)
   {
   
   
                 this.loginService.GetCollaboActorDetails().subscribe(data1=>{
   
                data1=JSON.parse(data1["_body"]);
                this.tempColaboActorDetails=JSON.parse(JSON.stringify(data1));
                    this.loginService.GetPraposalBids().subscribe(data=>
                      {
                        data = JSON.parse(data['_body']);
                          this.tempPraposaBids=JSON.parse(JSON.stringify(data));
   
   
                          this.loginService.GetHiredCollabarators().subscribe(data=>
                           {
                               data = JSON.parse(data['_body']);
                               this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));
   
                  var collabolist=this.tempCollaboList.filter(x=>x.userid.toString()==this.userID.toString() && x.parentcollaboid==0);
                       this.collaboList=collabolist;
                   
                       if(this.collaboList.length>0)
                       {
                      
                       var temp=this.tempCollaboList.filter(x=>x.userid.toString()==this.userID.toString() && x.parentcollaboid!=0);
   this.tempSubcollaboList=temp;
   
                  if(this.collaboList.length>0)
             
         
   for(let i=0;i<this.collaboList.length;i++)
   {
   let hiredDetails=this.tempHiredCollaboDetails.filter(x=>x.collaboid==this.collaboList[i].id)
   
   if(hiredDetails.length>0){
   this.HiredColaboDetals=hiredDetails;
   this.EachCollaboHired=hiredDetails.length;
   
   }
   else{
   this.HiredColaboDetals=[];
   this.EachCollaboHired="0";
   }
   let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===this.collaboList[i].id);
   
   if(CollaboActors.length>0)
   {
     this.ColaboActorDetails=CollaboActors;
   }
   else{
     this.ColaboActorDetails=[];
   }
   
     let tempSubCollabos=this.tempSubcollaboList.filter(x=>x.parentcollaboid===this.collaboList[i].id);
   
     
   if(tempSubCollabos.length>0)
   {
     this.IsSubCollabo=true;
   }
   else{
     this.IsSubCollabo=false;
   }
   let collabodetails:any
      collabodetails=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString());
   
      this.CollaboPraposalDetails=[];
   for(let i=0;i<collabodetails.length;i++ )
   {
      let filterHiredUsers=this.HiredColaboDetals.filter(x=>x.collaboid.toString()==collabodetails[i].collaboid && x.userid==collabodetails[i].userid)
   
     let IsHired:boolean=false;
   if(filterHiredUsers.length>0){
   IsHired=true;
   }else{
     IsHired=false
   }
   
   
     // if(filterHiredUsers.length>0){
       this.CollaboPraposalDetails.push({
         amount:collabodetails[i].amount,
         collaboid:collabodetails[i].collaboid,
         collabostatus:collabodetails[i].collabostatus,
         createdby:collabodetails[i].createdby,
   createddate: collabodetails[i].createddate,
   isactive: collabodetails[i].isactive,
   description:collabodetails[i].description,
   updatedby: collabodetails[i].updatedby,
   updateddate: collabodetails[i].updateddate,
   user_name:collabodetails[i].user_name,
   IsHired:IsHired,
   userid: collabodetails[i].userid,
   totalhours: collabodetails[i].totalhours,
   servicecharge:collabodetails[i].servicecharge,
   rowid: collabodetails[i].rowid,
   last_name: collabodetails[i].last_name,
   first_name:collabodetails[i].first_name,
   hoursestimated:collabodetails[i].hoursestimated,
       });
     }
   // }
      if(collabodetails.length>0)
      {
        this.EachCollaoBids=collabodetails.length;
     }
      else{
        this.EachCollaoBids="0";
      }
     if(this.collaboList[i].ActorID==undefined || this.collaboList[i].ActorID=="" || this.collaboList[i].ActorID==[])
     {this.Actorid="";}
     else
   { this. Actorid= JSON.parse(this.collaboList[i].ActorID)
   }
   
    if(this.collaboList[i].ActorPercentageID==undefined || this.collaboList[i].ActorPercentageID=="" || this.collaboList[i].ActorPercentageID==[])
    {this.ActorpercentageId="";
   }
    else
   {this. ActorpercentageId= JSON.parse(this.collaboList[i].ActorPercentageID)}
   
    
       this.tempCol.push({
           id:this.collaboList[i].id,
           category_id:this.collaboList[i].category_id,
           category: this.collaboList[i].category,
           sub_category_id: this.collaboList[i].sub_category_id,
           category1: this.collaboList[i].category1,
           name: this.collaboList[i].name,
           expected_budget: this.collaboList[i].expected_budget,
           estimated_time: this.collaboList[i].estimated_time,
           pay_type:this.collaboList[i].pay_type,
           status: this.collaboList[i].status,
           start_date:this.collaboList[i].start_date,
           end_date: this.collaboList[i].end_date,
           region: this.collaboList[i].region,
           SkillID: this.collaboList[i].SkillID,
           CollaboDocumentPath: this.collaboList[i].CollaboDocumentPath,
           ProjectPeriod: this.collaboList[i].ProjectPeriod,
           SpecificTimeline: this.collaboList[i].SpecificTimeline,
           //ActorID:this.Actorid ,
           ActorID:this.ColaboActorDetails,
           actorname: this.collaboList[i].actorname,
           PayValue: this.collaboList[i].PayValue,
           LegalDocumentPath: this.collaboList[i].LegalDocumentPath,
           createdby: this.collaboList[i].createdby,
           description: this.collaboList[i].description,
           skillname:this.collaboList[i].skillname,
           createddate:this.collaboList[i].createddate.split("T")[0],
           ActorPercentageID:this.ActorpercentageId,
           title:this.collaboList[i].title,
           statusname:this.collaboList[i].statusname,
            Bids:this.EachCollaoBids,
           SubCollabo:this.IsSubCollabo,
           SubCollaboList:tempSubCollabos,
           praposalBids:this.CollaboPraposalDetails,
           HiredDetails:this.HiredColaboDetals,
           HiredUsers:this.HiredUsers,
           Hired:this.EachCollaboHired
       }
       
       )
   
       this.statusChange(0);
   }
   }
   else{
     this.statusCollabos=[];
                        
   }
                        })
                       
                       })
                       
                        });
   
                      
                       }
                      else 
                       {
                       
                         this.statusCollabos=[];
                         
                       }
                       });
   
                      
       }
       Searchtext(){
        this.statusCollabos=[];
        this.statusCollabos=this.presentCollabos;
      
        this.tempcollabos = this.statusCollabos;
       
         let tempCompany = this.statusCollabos.filter(
           (item) => {
             return (
               (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
             );
           }
        
         );
         this.statusCollabos = tempCompany;
     
         
      }
       statusChange(id){
         this.tabStatus=id;
       
         this.statusCollabos=[];
        
           if(id===0)
           {
this.statusCollabos=this.tempCol;
           }
         else{
            this.statusCollabos=this.tempCol.filter(x=>x.status==id);
            
         }
         this.c=this.statusCollabos[0];
         this.presentCollabos=this.statusCollabos
      
       }
       accordianValue(value)
       {
         this.Accordian=value;
       }
}
